import { IFilterConfigItem } from '@/bundles/GroupFilters/interfaces/IFilterConfigItem';
import { FilterCategoryEnum, FilterTypeEnum } from '@/bundles/GroupFilters/enums/FilterTypeEnum';
import {
  getSignageInstallationTypeItems,
  getSignageSizeItems,
  getSignageStatusItems,
  getSignageTypeItems
} from '@/bundles/SignIn/helpers';
import { Nullable } from '@/utils/types';
import { formatToSF } from '@/bundles/GroupFilters/helpers/formatters/formatToSF';
import { getShowArchiveFilterConfig } from '@/bundles/GroupFilters/helpers/filtersConfig/getShowArchiveFilterConfig';

export const getSignListFilters = (): IFilterConfigItem[] => {
  return [
    // FilterCategoryEnum.sign_details start
    {
      title: 'Install Date',
      name: 'sign_install_date',
      type: FilterTypeEnum.date_range,
      category: FilterCategoryEnum.sign_details,
    },
    {
      title: 'Signage Status',
      name: 'sign_signage_status',
      type: FilterTypeEnum.autocomplete_multiple_select,
      items: getSignageStatusItems(),
      category: FilterCategoryEnum.sign_details,
    },
    {
      title: 'Signage Type',
      name: 'sign_signage_type',
      type: FilterTypeEnum.autocomplete_multiple_select,
      items: getSignageTypeItems(),
      category: FilterCategoryEnum.sign_details,
    },
    {
      title: 'Signage Size',
      name: 'sign_size',
      type: FilterTypeEnum.autocomplete_multiple_select,
      items: getSignageSizeItems(),
      category: FilterCategoryEnum.sign_details,
    },
    {
      title: 'Installation Type',
      name: 'sign_installation_type',
      type: FilterTypeEnum.autocomplete_multiple_select,
      items: getSignageInstallationTypeItems(),
      category: FilterCategoryEnum.sign_details,
    },
    {
      title: 'Building Size',
      name: 'sign_building_size',
      type: FilterTypeEnum.number_range,
      category: FilterCategoryEnum.sign_details,
      formatter: (v: Nullable<number>) => formatToSF(v),
    },
    {
      title: 'Brokers',
      name: 'sign_brokers',
      type: FilterTypeEnum.brokers_select,
      category: FilterCategoryEnum.sign_details,
    },
    // FilterCategoryEnum.sign_details end
    // FilterCategoryEnum.created_edited start
    {
      title: 'Created/Edited Date',
      name: 'sign_view_date',
      type: FilterTypeEnum.date_range,
      category: FilterCategoryEnum.created_edited,
    },
    {
      title: 'Created Date',
      name: 'sign_created_date',
      type: FilterTypeEnum.date_range,
      category: FilterCategoryEnum.created_edited,
    },
    {
      title: 'Edited Date',
      name: 'sign_edited_date',
      type: FilterTypeEnum.date_range,
      category: FilterCategoryEnum.created_edited,
    },
    {
      title: 'Created/Edited by',
      name: 'sign_view',
      type: FilterTypeEnum.create_updated_by_select, // should be handled in mappers to old filters
      category: FilterCategoryEnum.created_edited,
    },
    {
      title: 'Created by',
      name: 'sign_created_by',
      type: FilterTypeEnum.create_updated_by_select, // should be handled in mappers to old filters
      category: FilterCategoryEnum.created_edited,
    },
    {
      title: 'Edited by',
      name: 'sign_edited_by',
      type: FilterTypeEnum.create_updated_by_select, // should be handled in mappers to old filters
      category: FilterCategoryEnum.created_edited,
    },
    // FilterCategoryEnum.created_edited end
    getShowArchiveFilterConfig(),
  ].filter(Boolean) as IFilterConfigItem[];
};
